export const MAX_FILE_LIMIT = 10;
export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const allowedFileTypes = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];

export const formatFileSize = (size) => {
  if (size >= 1024 * 1024) {
    return (size / (1024 * 1024)).toFixed(2) + ' MB';
  } else {
    return (size / 1024).toFixed(2) + ' KB';
  }
};

export const truncateFilename = (filename, maxLength = 50) => {
  if (filename.length <= maxLength) return filename;

  const start = filename.slice(0, 30);
  const end = filename.slice(-7);
  return `${start}...${end}`;
};
